import styled from 'styled-components'

export const ExpirationContainer = styled.section`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 2.5rem;

  width: 100%;
  max-width: 1300px;

  margin: 0 auto;

  padding: 3.5rem 1rem;

  @media screen and (min-width: 800px) {
    padding: 3.5rem 4.875rem 3.5rem 6.875rem;
  }

  @media screen and (min-width: 1350px) {
    padding: 3.5rem 4.875rem 3.5rem;
  }

  hr {
    display: none;

    width: 100%;
    height: 1px;

    border: none;

    background: ${({ theme }) => `rgb(${theme.component.accent})`};
  }

  #desktopList {
    display: none;
  }

  @media screen and (min-width: 500px) {
    hr {
      display: initial;
    }
    #desktopList {
      display: initial;
    }
    #mobileList {
      display: none;
    }
  }
`

export const InitialText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  h1,
  p {
    margin: 0;
  }

  h1 {
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    font-size: 1.25rem;
    font-weight: 700;
  }

  p {
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    font-size: 1rem;
    font-weight: 500;
  }
`
